import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";

import { addLocaleData } from "react-intl";
import locale_en from 'react-intl/locale-data/en';
import locale_es from 'react-intl/locale-data/es';
import locale_bg from 'react-intl/locale-data/bg';

import translation_en from "./translations/en";
import translation_es from "./translations/es";
import translation_bg from "./translations/bg";

import App from "./components/App";

addLocaleData([...locale_en, ...locale_es, ...locale_bg]);

class Index extends React.Component {
    constructor() {
        super();

        this.translations = {
            en: translation_en,
            es: translation_es,
            bg: translation_bg
        }

        this.state = {
            locale: window.localStorage.getItem("locale") || "en",
            translation: this.translations.en,
            translation_stored: window.localStorage.getItem("language") || this.translations.en,
            recommendations: "en", 
            companydocuments: "en"
        }
    }

    componentDidMount(){
        this.changeLanguage(this.state.translation_stored);
    }

    changeLanguage = (language) => {
        switch (language) {
            case "en":
                window.localStorage.setItem("locale", "en");
                window.localStorage.setItem("language", "en");
                this.setState({
                    locale: "en",
                    translation: this.translations.en,
                    recommendations: "en",
                    companydocuments: "en"
                });

                break;
            
            case "es":
                    window.localStorage.setItem("locale", "es");
                    window.localStorage.setItem("language", "es");
                    this.setState({
                        locale: "es",
                        translation: this.translations.es,
                        recommendations: "es",
                        companydocuments: "es"
                    });
    
                    break;

            case "bg":
                window.localStorage.setItem("locale", "bg");
                window.localStorage.setItem("language", "bg");
                this.setState({
                    locale: "bg",
                    translation: this.translations.bg,
                    recommendations: "bg",
                    companydocuments: "bg"
                });

                break;

            default:
                break;
        }
    }

    render() {
        return <IntlProvider locale={this.state.locale} messages={this.state.translation}><App languageSelection={this.changeLanguage} recommendations={this.state.recommendations} companydocuments={this.state.companydocuments}/></IntlProvider>
    }

}

ReactDOM.render(<Index />, document.querySelector("#root"));